// extracted by mini-css-extract-plugin
export default {"skChase":"LoadingIndicator_skChase__G2R4r","skChaseDot":"LoadingIndicator_skChaseDot__nw93W","skChaseDot-before":"LoadingIndicator_skChaseDot-before__VWTi4"};